export default function stopImmediatePropagation(event: Event): void {
  // console.log('stopImmediatePropagation', event.type, event)
  event.stopImmediatePropagation()
}
